import { GrowthBook } from '@growthbook/growthbook-react';
import { isProduction } from 'utils';

import { GROWTHBOOK_API_HOST, GROWTHBOOK_CLIENT_KEY_DEV, GROWTHBOOK_CLIENT_KEY_PROD } from './config';

// Create a GrowthBook instance
export const growthbook = new GrowthBook({
  apiHost: GROWTHBOOK_API_HOST,
  clientKey: isProduction() ? GROWTHBOOK_CLIENT_KEY_PROD : GROWTHBOOK_CLIENT_KEY_DEV,
  subscribeToChanges: true,
  enableDevMode: !isProduction(),
});
